import axios from 'axios';
import {
  getErrorMessageTimeout,
  getFromLocalStorage,
  setToLocalStorage,
} from '../../global/helpers';
import {
  ApplyRecipePayload,
  CheckProvisionPayload,
  GetRecipeInfoPayload,
  GetSuitableMedicationsPayload,
} from './types';

export class RXGateService {
  static API_ALO_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v2/islo/alo/`;

  static API_RXGATE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/rxgate/`;

  // Лаконичный хелпер, чтобы дублировать системный показ ErrorAlertModal и для fetch-запросов.
  private static pushErrorToModal({
    url,
    status,
    errorMessage,
    code = null,
    body = null,
    xRequestId = '',
    xTraceId = '',
  }: {
    url: string;
    status: number | string;
    errorMessage: string;
    code?: string | null;
    body?: any;
    xRequestId?: string;
    xTraceId?: string;
  }) {
    setToLocalStorage('requestErrorData', {
      url,
      status,
      error_message: errorMessage,
      code,
      body,
      token: getFromLocalStorage('accessToken'),
      time: getErrorMessageTimeout(),
      x_trace_id: xTraceId,
      x_request_id: xRequestId,
    });
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: 'requestErrorData',
      })
    );
  }

  // Унифицированный обработчик axios-ошибок для всех эндпоинтов.
  private static handleAxiosError(error: any, fallbackUrl: string) {
    const status = error?.response?.status || '';
    const data = error?.response?.data;
    const url =
      error?.request?.responseURL || error?.config?.url || fallbackUrl;
    const errorMessage =
      data?.request_error?.error_info?.error_message ||
      data?.message ||
      data?.detail ||
      error?.message ||
      'Network Error';
    const normalizedErrorMessage =
      typeof errorMessage === 'string'
        ? errorMessage
        : JSON.stringify(errorMessage || 'Network Error');
    const code = data?.request_error?.code || null;
    const xRequestId = error?.response?.headers?.['x-request-id'] || '';
    const xTraceId = error?.response?.headers?.['x-trace-id'] || '';
    RXGateService.pushErrorToModal({
      url,
      status,
      errorMessage: normalizedErrorMessage,
      code,
      body: data || null,
      xRequestId,
      xTraceId,
    });
  }

  static getRecipeInfo = async (payload: GetRecipeInfoPayload) => {
    const url = `${RXGateService.API_ALO_URL}recipe/search`;
    const data = {
      recipe_id: Number(payload.recipe),
      IIN: btoa(payload.iin),
      phone: payload.phone?.replace(/[^\d]/g, ''),
    };
    try {
      const response = await axios({
        method: 'post',
        url,
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (err) {
      RXGateService.handleAxiosError(err, url);
      throw err;
    }
  };

  static getSuitableMedications = async (
    payload: GetSuitableMedicationsPayload
  ) => {
    const url = `${RXGateService.API_RXGATE_URL}products/search`;
    const data = {
      tradeNameUUIDs: payload.nameCodeList,
    };
    try {
      const response = await axios({
        method: 'post',
        url,
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (err) {
      RXGateService.handleAxiosError(err, url);
      throw err;
    }
  };

  // Захардкожено чтобы возвращало успех, ждем уточнения по ручке
  static checkProvision = async (payload: CheckProvisionPayload) => {
    const url = `${RXGateService.API_ALO_URL}recipe/provision/check`;
    try {
      const response = await axios({
        method: 'post',
        url,
        data: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (err) {
      RXGateService.handleAxiosError(err, url);
      throw err;
    }
  };

  static getRxGateCurrentReceipt = async (id: string) => {
    const url = `${RXGateService.API_RXGATE_URL}doc/active?recipeID=${id}`;
    try {
      const response = await axios({
        method: 'get',
        url,
      });
      return response.data;
    } catch (err) {
      RXGateService.handleAxiosError(err, url);
      throw err;
    }
  };

  // Захардкожено чтобы возвращало успех,
  // будет либо новая(эта) ручка либо submitLoyaltyOrder перепишут из loyalty
  static applyRecipe = async (payload: ApplyRecipePayload) => {
    // const url = `${RXGateService.API_BASE_URL}islo/alo/recipe/provision/check`;
    // try {
    //   const response = await axios({
    //     method: 'post',
    //     url,
    //     data: payload,
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   });
    //   return response.data;
    // } catch (err) {
    //   RXGateService.handleAxiosError(err, url);
    //   throw err;
    // }
    return { status: 'success' };
  };
}
